<!-- ページ共通ヘッダー: ロゴ・ナビ・タイトル帯・リード文を含む -->
<template>
  <div>
    <!-- ヘッダー -->
    <header class="top-header">
      <div class="top-header-inner">
        <div class="logo-container">
          <img :src="logoPath" alt="ロゴ" class="logo-image" @error="(event) =>((event.target as HTMLImageElement).src = defaultLogoPath)"
          />
        </div>
        <nav class="top-menu">
          <!-- <a href="#">試用版導入までの流れ</a>
          <a href="#">オプションについて</a>
          <a href="#">よくあるご質問</a> -->
        </nav>
      </div>
    </header>

    <!-- タイトル帯 -->
    <div class="header-pattern">
      <div class="pattern-inner">
        <h1>試用版申し込みフォーム</h1>
      </div>
    </div>

    <!-- リード文 -->
    <div class="content-container-header">
      <p class="lead-text">
        下記内容をご確認いただき、必要事項をご記入ください。
      </p>
      <ul class="lead-list">
        <li>試用版では、ユーザー数は10までとなります。</li>
        <li>
          試用版では、お申し込み日から3ヶ月後（暫定）に自動解約となります。
        </li>
        <li>
          メールによる「製品・サポート情報」を配信しております。ご希望されない場合は、無償バージョンアップなどの有益な情報やセキュリティにかかわる重要な情報も、配信されないことをご了承ください。
        </li>
        <li>
          お申込みに際して
          <a
            href="https://www.dds.co.jp/wp-content/uploads/2025/06/evecloud-termsofservice_D230351.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            利用規約
          </a>
          をご確認いただきますようお願い申し上げます。
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  getLogoPath,
  getDefaultLogoPath,
} from "@/function/setting/ProductResources";

const logoPath = getLogoPath();
const defaultLogoPath = getDefaultLogoPath();
</script>
